import React from 'react'
import styled from 'styled-components'
import InputWrapper from 'src/components/InputWrapper'
import SectionTitle from 'src/components/SectionTitle'
import { Input } from 'semantic-ui-react'
import { AppContext } from 'src/context/AppContext'
import { numberValidate } from 'src/validator'

const YearAdvancedSetting = () => (
  <AppContext.Consumer>
    {({ state, actions }) => (
      <InputWrapper>
        <SectionTitle>日付</SectionTitle>
        <div>
          <Input
            name={'month'}
            type={'number'}
            placeholder={1}
            min={1}
            max={12}
            value={state.month}
            onChange={actions.onChangeInput}
            error={state.submitted && !!numberValidate(state.month, 12, '月')}
          />
          月
          <StyledInput
            name={'day'}
            type={'number'}
            placeholder={1}
            min={1}
            max={31}
            value={state.day}
            onChange={actions.onChangeInput}
            errors={state.submitted && !!numberValidate(state.day, 31, '日')}
          />
          日
        </div>
      </InputWrapper>
    )}
  </AppContext.Consumer>
)

export default YearAdvancedSetting

const StyledInput = styled(Input)`
  && {
    margin-left: 12px;
  }
`
